import React, { Component } from 'react';
import { connect } from 'react-redux';
import classnames from 'classnames';
import FooterButtonGroups from './FooterButtonGroups';
import { EDITOR_MODE_HTML } from '../../constants/EditorMode';
import ToastMessage from './ToastMessage';
import { updateMessage } from '../../actions';
import StatusTextBar from './StatusTextBar';

@connect(state => ({
  uploadProgressCount: state.post.uploadProgressCount,
  editorMode: state.env.editorMode,
  footerVisible: state.env.footerVisible,
}), dispatch => ({}))
class PostEditorFooter extends Component {
  render () {
    const { editorMode, footerVisible, uploadProgressCount } = this.props;

    const message = `${uploadProgressCount}개의 파일을 업로드 중입니다.`;
    const open = uploadProgressCount > 0;

    return (
      <div className={classnames('content-aside', {
        'content-aside-type1': editorMode === EDITOR_MODE_HTML,
        'no-footer': !footerVisible,
      })}>
        <FooterButtonGroups/>
        <ToastMessage open={open} message={message} />
      </div>
    );
  }
}

export default PostEditorFooter;
